import { DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST, CREATE_DRAFT_CREDIT_NOTE_BILL_BASE, GET_DRAFT_CREDIT_NOTE_BILL_BASES, UPDATE_DRAFT_CREDIT_NOTE_BILL_BASE,
  DELETE_DRAFT_CREDIT_NOTE_BILL_BASE, DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_SUCCESS, 
  GET_DRAFT_CREDIT_NOTE_BILL_BASES_PAGE } from '../types';

const initialState = {
  draftCreditNoteBillBases: [],
  draftCreditNoteBillBasesPage: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const draftCreditNoteBillBaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_DRAFT_CREDIT_NOTE_BILL_BASES: {
      return {
        ...state,
        draftCreditNoteBillBases: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_DRAFT_CREDIT_NOTE_BILL_BASES_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        draftCreditNoteBillBasesPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_DRAFT_CREDIT_NOTE_BILL_BASE: {
      return {
        ...state,
        draftCreditNoteBillBases: [action.payload, ...state.draftCreditNoteBillBases],
        loading: false,
        error: null
      };
    }
    case UPDATE_DRAFT_CREDIT_NOTE_BILL_BASE: {
      const draftCreditNoteBillBasesData = state.draftCreditNoteBillBases.slice(0);
      const uIndex = draftCreditNoteBillBasesData.findIndex((data) => data.id === action.payload.id);
      draftCreditNoteBillBasesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        draftCreditNoteBillBases: [ ...draftCreditNoteBillBasesData ],
        loading: false,
        error: null
      };
    }
    case DELETE_DRAFT_CREDIT_NOTE_BILL_BASE: {
      const draftCreditNoteBillBases = state.draftCreditNoteBillBases?.slice(0);
      const index = draftCreditNoteBillBases.findIndex((data) => data.id === action.id);
      if (index > -1) {
        draftCreditNoteBillBases.splice(index, 1);
      }
      return {
        ...state,
        draftCreditNoteBillBases: [...draftCreditNoteBillBases],
        loading: false,
        error: null
      }
    }
    case DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default draftCreditNoteBillBaseReducer;